// extracted by mini-css-extract-plugin
module.exports = {"internalLink":"internal-link-module--internal-link--3xFWc","thin":"internal-link-module--thin--3EPZm","active":"internal-link-module--active--3PXns"};